import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const MapAttribution = ({ currentBasemap }) => {
    const getAttributionContent = () => {
        switch (currentBasemap) {
            case 'bing-aerial':
            case 'bing-aerial-labels':
                // Bing aerial imagery attribution
                return (_jsx("a", { href: "https://www.bingmapsportal.com/terms", target: "_blank", rel: "noopener noreferrer", children: "\u00A9 Bing Aerial Imagery" }));
            case 'usgs-satellite':
                // USGS satellite - no specific attribution needed
                return null;
            case 'usgs-topo':
                // USGS topography attribution only
                return (_jsx("a", { href: "https://www.usgs.gov/", target: "_blank", rel: "noopener noreferrer", children: "\u00A9 USGS" }));
            case 'carto-light':
            case 'carto-dark':
                // CARTO attribution only
                return (_jsx("a", { href: "https://carto.com/", target: "_blank", rel: "noopener noreferrer", children: "\u00A9 CARTO" }));
            default:
                // Default case - no attribution
                return null;
        }
    };
    const attributionContent = getAttributionContent();
    // Don't render if there's no attribution content
    if (!attributionContent) {
        return null;
    }
    return (_jsx("div", { className: "fixed bottom-1 left-2 z-30 pointer-events-auto", style: {
            fontSize: '10pt',
            color: 'white',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8), -1px -1px 2px rgba(0, 0, 0, 0.8), 1px -1px 2px rgba(0, 0, 0, 0.8), -1px 1px 2px rgba(0, 0, 0, 0.8)',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        }, children: attributionContent }));
};
